import {
  GET_SETTINGS,
  GET_SETTINGS_FAILURE,
  GET_SETTINGS_SUCCESS,
  UPDATE_SETTINGS,
  UPDATE_SETTINGS_FAILURE,
  UPDATE_SETTINGS_SUCCESS,
} from "../../Actions/types";

const initialState = {
  getLoader: false,
  getData: null,
  getError: false,
  updateLoader: false,
  updateData: null,
  updateError: false,
};
function settingsReducer(state = initialState, action) {
  switch (action.type) {
    case GET_SETTINGS:
      return { ...state, getLoader: true };
    case GET_SETTINGS_SUCCESS:
      return { ...state, getData: action?.payload, getLoader: false };
    case GET_SETTINGS_FAILURE:
      return { ...state, getError: true, getLoader: false };

    case UPDATE_SETTINGS:
      return { ...state, updateLoader: true };
    case UPDATE_SETTINGS_FAILURE:
      return { ...state, updateData: action?.payload, updateLoader: false };
    case UPDATE_SETTINGS_SUCCESS:
      return { ...state, updateError: true, updateLoader: false };

    default:
      return state;
  }
}

export default settingsReducer;
